<!-- close / iOS -->
<button class="pos-absolute right-2 top-2 z-9 p-a _close"
        [attr.aria-label]="'Close' | translate"
        (click)="modalClose()">
    <i class="icon-close"
       aria-hidden="true"></i>
</button>

<div class="p-a _message">
    <p class="p1">{{'A new version of this app is available.' | translate}}</p>
</div>

<!-- buttons / ANDROID -->
<div class="p-a _actions">
    <!-- close -->
    <button class="m-r"
            buttonStyle="button-1"
            (click)="modalClose()">{{'Close' | translate}}</button>

    <button class="flex-grow-s"
            buttonStyle
            (click)="reload()">{{'Update now' | translate}}</button>
</div>